(function () {
  document.addEventListener('DOMContentLoaded', initSilentAddToCart);
  document.addEventListener('shopify:section:load', initSilentAddToCart);

  if (window.customElements) {
    customElements.whenDefined('product-form').then(() => {
      initSilentAddToCart();
    });
  }

  function initSilentAddToCart() {
    patchProductFormPrototype();
    patchExistingProductForms();
  }

  function patchProductFormPrototype() {
    const ProductForm = customElements.get('product-form');

    if (!ProductForm || ProductForm.prototype._silentAddToCartPatched) return;

    ProductForm.prototype.redirectAfterSubmit = silentRedirectAfterSubmit;
    ProductForm.prototype._silentAddToCartPatched = true;
  }

  function patchExistingProductForms() {
    const productForms = document.querySelectorAll('product-form');

    productForms.forEach((productForm) => {
      if (productForm._silentAddToCartInstancePatched) return;

      productForm.redirectAfterSubmit = silentRedirectAfterSubmit.bind(productForm);
      productForm._silentAddToCartInstancePatched = true;
    });
  }

  function silentRedirectAfterSubmit(response) {
    const clickedButton = getClickedSubmitButton(this);
    const isCart = isCartPage();

    if (clickedButton) {
      setTimeout(() => {
        showTextButtonFeedback(clickedButton);
      }, 250);
    }

    refreshCartUI(response).finally(() => {
      closeCartDrawer();

      if (isCart) {
        setTimeout(() => {
          window.location.reload();
        }, 300);
      }
    });
  }

  function getClickedSubmitButton(productForm) {
    const activeElement = document.activeElement;

    if (
      activeElement &&
      activeElement.matches &&
      activeElement.matches(
        '.product-form__submit, .wt-product__sticky-buy__button, [type="submit"]'
      )
    ) {
      return activeElement;
    }

    return productForm.querySelector(
      '.product-form__submit, .wt-product__sticky-buy__button, [type="submit"]'
    );
  }

  function showTextButtonFeedback(button) {
    if (!button) return;

    button.classList.remove('loading');
    button.removeAttribute('aria-disabled');
    button.disabled = false;
    button.style.pointerEvents = 'auto';

    const spinner = button.querySelector('.loading-overlay__spinner');
    if (spinner) spinner.classList.add('hidden');

    button.classList.add('is-added-custom');

    clearTimeout(button._addedTextTimeout);

    button._addedTextTimeout = setTimeout(() => {
      button.classList.remove('is-added-custom');
    }, 1200);
  }

  async function silentAddFormToCart(form) {
    const formData = new FormData(form);

    const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      body: formData
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok || data.status) {
      throw new Error(data.description || data.message || 'Add to cart failed');
    }

    return data;
  }

  async function refreshCartUI(response) {
    try {
      if (response && response.sections) {
        updateCartFromSections(response.sections);
        return;
      }

      const cacheBustUrl =
        window.location.pathname +
        window.location.search +
        (window.location.search ? '&' : '?') +
        '_cart_refresh=' +
        Date.now();

      const htmlResponse = await fetch(cacheBustUrl, {
        headers: {
          Accept: 'text/html'
        }
      });

      const html = await htmlResponse.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      updateHeaderCounterFromDocument(doc);
      updateCartDrawerFromDocument(doc);
    } catch (error) {
      console.error('Cart UI refresh failed:', error);
    }
  }

  function updateCartFromSections(sections) {
    if (!sections || typeof sections !== 'object') return;

    Object.keys(sections).forEach((sectionId) => {
      const sectionHtml = sections[sectionId];
      if (!sectionHtml) return;

      const parser = new DOMParser();
      const doc = parser.parseFromString(sectionHtml, 'text/html');

      updateHeaderCounterFromDocument(doc);
      updateCartDrawerFromDocument(doc);
    });
  }

  function updateHeaderCounterFromDocument(doc) {
    const newCounter = doc.querySelector('.wt-header__panel__counter');
    const currentCounter = document.querySelector('.wt-header__panel__counter');

    const currentCartLink = document.querySelector(
      '.wt-header__panel__item--cart .wt-header__panel__link, .wt-cart__trigger'
    );

    if (newCounter && currentCounter) {
      currentCounter.replaceWith(newCounter);
    } else if (newCounter && !currentCounter && currentCartLink) {
      const label = currentCartLink.querySelector('.wt-header__panel__label');

      if (label) {
        label.insertAdjacentElement('beforebegin', newCounter);
      } else {
        currentCartLink.appendChild(newCounter);
      }
    }
  }

  function updateCartDrawerFromDocument(doc) {
    const newDrawerInner = doc.querySelector('#CartDrawer .wt-cart__drawer__inner');
    const currentDrawerInner = document.querySelector('#CartDrawer .wt-cart__drawer__inner');

    if (newDrawerInner && currentDrawerInner) {
      currentDrawerInner.replaceWith(newDrawerInner);
    }
  }

  function closeCartDrawer() {
    const cartDrawerTag = document.querySelector('cart-drawer');
    const cartDrawer = document.getElementById('CartDrawer');
    const overlay = document.querySelector('.page-overlay-cart');

    if (cartDrawerTag) {
      cartDrawerTag.removeAttribute('open');
    }

    if (cartDrawer) {
      cartDrawer.classList.remove('wt-cart__drawer--open');
    }

    if (overlay) {
      overlay.style.opacity = '0';
      overlay.style.pointerEvents = 'none';
    }

    document.body.classList.remove('page-overlay-cart-on');
  }

  function isCartPage() {
    const path = window.location.pathname.replace(/\/$/, '');

    if (path === '/cart' || path === '/en/cart') {
      return true;
    }

    if (document.body.classList.contains('template-cart')) {
      return true;
    }

    if (
      document.querySelector('main form[action="/cart"]') ||
      document.querySelector('main form[action*="/cart"]') ||
      document.querySelector('main [data-cart-page]') ||
      document.querySelector('main .wt-cart')
    ) {
      return true;
    }

    return false;
  }

  async function silentAddSiblingByHandle(handle) {
    const productUrl = buildProductJsonUrl(handle);

    const productRes = await fetch(productUrl, {
      headers: {
        Accept: 'application/json'
      }
    });

    if (!productRes.ok) throw new Error('Failed to load sibling product');

    const product = await productRes.json();
    const variant = product.variants?.find((v) => v.available) || product.variants?.[0];

    if (!variant?.id) throw new Error('No variant found for sibling product');

    const addRes = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: variant.id,
        quantity: 1
      })
    });

    const data = await addRes.json().catch(() => ({}));

    if (!addRes.ok || data.status) {
      throw new Error(data.description || data.message || 'Sibling add to cart failed');
    }

    await refreshCartUI(data);
    closeCartDrawer();

    return data;
  }

  function buildProductJsonUrl(handle) {
    const localePrefix = window.location.pathname.startsWith('/en') ? '/en' : '';
    return `${localePrefix}/products/${handle}.js`;
  }

  window.silentAddFormToCart = silentAddFormToCart;
  window.silentAddSiblingByHandle = silentAddSiblingByHandle;
  window.refreshCartUI = refreshCartUI;
  window.closeCartDrawer = closeCartDrawer;
})();